import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import logo from "../HslLogo.png";

const LINKS = [
  { label: "Fixtures", to: "/schedule" },
  { label: "Standings", to: "/standings" },
  { label: "Stats", to: "/stats" },
  { label: "Insights", to: "/insights" },
  { label: "Rules", to: "/rules" },
  { label: "Jobs", to: "/jobs" },
  { label: "Register", to: "/register/select-division" },
];

const Footer = () => (
  <Box component="footer" sx={{ mt: 4, bgcolor: "#0a0a0a", color: "rgba(255,255,255,0.75)" }}>
    <Box
      sx={{
        maxWidth: 1080,
        mx: "auto",
        px: { xs: 2.5, sm: 3 },
        py: { xs: 3.5, sm: 4 },
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        gap: 2.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box component="img" src={logo} alt="HSL" sx={{ height: 34, width: "auto" }} />
        <Typography sx={{ fontSize: "0.82rem", lineHeight: 1.35 }}>
          HADAF Soccer League
          <Box component="span" sx={{ display: "block", opacity: 0.55, fontSize: "0.75rem" }}>
            Fixtures, tables and registration
          </Box>
        </Typography>
      </Box>
      <Box component="nav" aria-label="Footer" sx={{ display: "flex", flexWrap: "wrap", columnGap: 2.5, rowGap: 1 }}>
        {LINKS.map((l) => (
          <Link key={l.to} component={RouterLink} to={l.to} underline="hover" sx={{ color: "inherit", fontSize: "0.85rem", fontWeight: 600 }}>
            {l.label}
          </Link>
        ))}
      </Box>
    </Box>
    <Box
      sx={{
        borderTop: "1px solid rgba(255,255,255,0.08)",
        maxWidth: 1080,
        mx: "auto",
        px: { xs: 2.5, sm: 3 },
        py: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        fontSize: "0.75rem",
        color: "rgba(255,255,255,0.5)",
      }}
    >
      <span>© {new Date().getFullYear()} HADAF Soccer League</span>
      <Link
        href="https://www.instagram.com/hadafsoccerleague"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{ color: "inherit", display: "inline-flex", alignItems: "center", gap: 0.5 }}
      >
        <InstagramIcon sx={{ fontSize: 16 }} />
        @hadafsoccerleague
      </Link>
    </Box>
  </Box>
);

export default Footer;
